<template>
  
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            projectSidebar: "ui/projectSidebar",
        })
    }
}
</script>
